/**
 * The Connect a bank stepper's strings (piece 24; decision 1770), kept beside
 * its rules and spread into the one lookup in `strings.ts`. 🔨 This file
 * imports nothing, because the lookup imports it.
 */
export const BANK_STEPS_STRINGS = {
  'banking.steps.title': 'Connect a bank',
  'banking.steps.hint': 'Five steps take a bank account from nothing to a reconciled statement. A step ticks itself once what it asks for is saved.',
  'banking.steps.guide': 'Connect a Bank Guide',
  'banking.steps.guideHide': 'Hide the Guide',
  'banking.steps.keys.title': 'The feed keys are held',
  'banking.steps.keys.body': 'Plaid’s client id and secret are entered once, on Settings › Integrations. Until both are held, no bank can be signed in to.',
  'banking.steps.keys.done': 'Plaid’s keys are held.',
  'banking.steps.keys.open': 'Open Plaid setup',
  'banking.steps.account.title': 'An account is connected',
  'banking.steps.account.body': 'Open an account below, press Connect and sign in at the bank. A new account starts at Not connected.',
  'banking.steps.account.done': 'Connected accounts',
  'banking.steps.firstPull.title': 'The first pull is in',
  'banking.steps.firstPull.body': 'The feed delivers lines on its own schedule. They count under Amount in Bank Feed and wait on the account’s page to be matched.',
  'banking.steps.firstPull.done': 'Lines pulled',
  'banking.steps.tiers.title': 'The match confidence tiers are set',
  'banking.steps.tiers.body': 'Three numbers decide what counts as a High, Medium or Low match. Save each one once, even where the default suits.',
  'banking.steps.tiers.done': 'All three tiers are saved.',
  'banking.steps.tiers.some': 'Tiers saved',
  'banking.steps.tiers.open': 'Open Match Confidence Tiers',
  'banking.steps.reconciled.title': 'The first reconciliation is closed',
  'banking.steps.reconciled.body': 'Open an account, start a reconciliation against its statement, clear the lines and complete it when the difference is zero.',
  'banking.steps.reconciled.done': 'A reconciliation is completed.',
  'banking.steps.of': 'of',
  'banking.steps.account.waits': 'Enter the feed keys on step 1 first.',
  'banking.steps.firstPull.waits': 'Connect an account on step 2 first.',
  'banking.steps.reconciled.waits': 'Pull the first bank lines on step 3 first.',
} as const;
